import { render, staticRenderFns } from "./BabyAlbumCard.vue?vue&type=template&id=de8a4638&scoped=true"
import script from "./BabyAlbumCard.vue?vue&type=script&lang=js"
export * from "./BabyAlbumCard.vue?vue&type=script&lang=js"
import style0 from "./BabyAlbumCard.vue?vue&type=style&index=0&id=de8a4638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8a4638",
  null
  
)

export default component.exports